module.exports = __webpack_public_path__ + "static/img/T-360-1.ced9b92b.png";